import { TravelStatusEnum } from 'types';

import { AdditionQuestionsEnum } from '../types';
import { ITravelStatus } from '../../../../../../../../types';

import { Booked } from './components/Booked';
import { TravelCancelled } from './components/TravelCancelled';
import { TravelPrevented } from './components/TravelPrevented';
import { Defer } from './components/Defer';
import { Withdraw } from './components/Withdraw';
import { Arrived } from './components/Arrived';
import { AlreadyInUk } from './components/AlreadyInUk';
import { NoBookingYet } from './components/NoBookingYet';
import { NewArrivedDate } from './components/NewArrivedDate';

interface IProps {
  status: ITravelStatus['status'] | AdditionQuestionsEnum;
  setComplete: (status: boolean) => void;
  travelStatus: ITravelStatus;
  additionalAnswers: {
    answers: Omit<ITravelStatus, 'status'>;
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
}

export const AdditionalQuestions = (props: IProps) => {
  const {
    status,
    additionalAnswers: { setAnswers },
    setComplete,
    travelStatus
  } = props;

  switch (status) {
    case TravelStatusEnum.Booked: {
      return <Booked additionalAnswers={{ setAnswers }} setComplete={setComplete} />;
    }
    case TravelStatusEnum.TravelCancelled: {
      return <TravelCancelled additionalAnswers={{ setAnswers }} setComplete={setComplete} />;
    }
    case TravelStatusEnum.TravelPrevented: {
      return <TravelPrevented additionalAnswers={{ setAnswers }} setComplete={setComplete} />;
    }
    case TravelStatusEnum.Defer: {
      return <Defer additionalAnswers={{ setAnswers }} setComplete={setComplete} />;
    }
    case TravelStatusEnum.Withdraw: {
      return <Withdraw additionalAnswers={{ setAnswers }} setComplete={setComplete} />;
    }
    case AdditionQuestionsEnum.NewArrivedDate: {
      return (
        <NewArrivedDate travelStatus={travelStatus} additionalAnswers={{ setAnswers }} setComplete={setComplete} />
      );
    }
    case TravelStatusEnum.Arrived: {
      return <Arrived additionalAnswers={{ setAnswers }} setComplete={setComplete} />;
    }
    case TravelStatusEnum.AlreadyInUk: {
      return <AlreadyInUk setComplete={setComplete} />;
    }
    case TravelStatusEnum.NoBookingYet: {
      return <NoBookingYet setComplete={setComplete} />;
    }
    default: {
      return <></>;
    }
  }
};
